import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import useAuth from '../hooks/useAuth';
import useApi from '../hooks/useApi';
import UserService from '../services/user.service';
import { useTranslation } from 'react-i18next';
import useLogout from '../hooks/useLogout';




const Header = ({ className = "", compactLanguage = true }) => {
  const logout = useLogout();
  const navigate = useNavigate();
  const api = useApi();
  const { auth } = useAuth();
  const [user, setUser] = useState();
  const { t, i18n } = useTranslation('payment');

  const handleGoBack = () => {
    if (auth.user?.status === 'PENDING_PHONE_VERIFICATION') {
      logout();
      navigate("/login");
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        const response = await UserService.currentUser({ with: 'notifications' }, api)
        console.log(response)
        isMounted && setUser(response);
      } catch (err) {
        console.error(err);
      }
    };

    if (!auth || Object.keys(auth).length === 0) {
      return;
    }
    getUsers();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);


  const unreadCount = user?.user?.notifications?.filter(
    (notification) => notification.is_read !== true
  ).length || 0;

  return (
    <div className={`header headFix ${className}`.trim()} >
      <div className="turn-back">
        <div className="frame">
          <div className="div" onClick={handleGoBack} >{"<"} {t('payment:back')}</div>
        </div>
      </div>
      <a href="/" className="logo hlogo">Flyspa</a>
      <div>
        <LanguageSwitcher compact={compactLanguage} />
      </div>
    </div>
  );
};

export default Header;
